import React, { useState } from 'react';
import axios from 'axios';
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  Paper,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState(false);
  const navigate = useNavigate(); // Inicializa el hook useNavigate

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensaje('');
    setError(false);

    try {
      const response = await axios.post('https://softwaregestion-production-b8ad.up.railway.app/api/login', {
        email,
        password,
      });

      const { token, userId, role } = response.data;

      localStorage.setItem('token', token);
      localStorage.setItem('userId', userId);
      localStorage.setItem('role', role);

      setMensaje('Inicio de sesión exitoso');
      setError(false);

      // Redirige al inicio después de un inicio de sesión exitoso
      navigate('/'); // '/' es la ruta del inicio
    } catch (err) {
      console.error('Error al iniciar sesión:', err);
      setMensaje(err.response?.data?.message || 'Error al iniciar sesión');
      setError(true);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to right, #6a11cb, #2575fc)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Paper elevation={6} sx={{ p: 4, borderRadius: 4, width: 350 }}>
        <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 600 }}>
          Bienvenido
        </Typography>
        <Typography variant="subtitle1" align="center" sx={{ mb: 2 }}>
          Inicia sesión en tu cuenta
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Correo electrónico"
            type="email"
            fullWidth
            margin="normal"
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <TextField
            label="Contraseña"
            type="password"
            fullWidth
            margin="normal"
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{
              mt: 2,
              py: 1.5,
              backgroundColor: '#6a11cb',
              '&:hover': { backgroundColor: '#5a0dbb' },
              fontWeight: 'bold',
              fontSize: '16px',
            }}
          >
            Iniciar Sesión
          </Button>
        </form>
        {mensaje && (
          <Alert severity={error ? 'error' : 'success'} sx={{ mt: 3 }}>
            {mensaje}
          </Alert>
        )}
      </Paper>
    </Box>
  );
};

export default Login;
